/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import CModalWindow from '../common/modal/modalWindow.component.container';
import DocumentStatusContainer from './document.status.container';

class DocumentStatusModal extends React.Component {
  render() {
    return (
      <div id="document-status-modal">
        <DocumentStatusContainer {...this.props} />
      </div>
    );
  }
}

export default DocumentStatusModal;
